// extracted by mini-css-extract-plugin
export var borderRadius = "_a8-4";
export var large = "_a8-3";
export var logoContainer = "_a8-0";
export var nameLogo = "_a8-2";
export var small = "_a8-1";